import { __rest } from "tslib";
import * as React from 'react';
import { View, TouchableWithoutFeedback } from 'react-native';
import { DeviceInfo } from 'qunar-react-native';
import Tip from './Tip';
import { RightIcon } from './TipIcon';
import { TipTheme } from './TipTypes';
import TipsStyle from './style';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
const STYLE = new TipsStyle(false);
// DeviceInfo.isNotRn 是三端镜像工具中提供的api，qrn中是不支持的，所以qrn中正常得到是undefined，isApp始终为true
// @ts-ignore
const isApp = !DeviceInfo.isNotRn;
export default class Tips extends React.Component {
    constructor(props) {
        super(props);
        this.onPress = () => {
            const { onPress } = this.props;
            if (onPress) {
                onPress();
            }
        };
        this.onClose = () => {
            const { mode, onClose } = this.props;
            if (mode === 'closable') {
                this.setState({
                    show: false
                });
            }
            if (onClose) {
                onClose();
            }
        };
        STYLE.setIsScale(props.needScale);
        this.state = {
            show: true
        };
    }
    render() {
        let _a = this.props, { tipList, rightIcon, themeType, customStyle, mode, needScale, accessibilityPreName } = _a, props = __rest(_a, ["tipList", "rightIcon", "themeType", "customStyle", "mode", "needScale", "accessibilityPreName"]);
        let styles = STYLE.getStyle();
        customStyle = customStyle
            ? customStyle
            : TipTheme[themeType];
        const main = Array.isArray(tipList) && tipList.length
            ? tipList.map((item, index) => {
                return (<Tip key={item.title + 'tip' + index} index={index} {...Object.assign(Object.assign({}, props), item)} style={styles.tipItem}/>);
            })
            : null;
        return this.state.show ? (<TouchableWithoutFeedback onPress={this.onPress} accessible={false} {...qAccessibilityLabel(`${accessibilityPreName}qdTip`)}>
                <View style={[
            styles.tipsContainer,
            {
                backgroundColor: customStyle === null || customStyle === void 0 ? void 0 : customStyle.backgroundColor
            },
            !isApp ? { width: '100%' } : null
        ]}>
                    <View style={{ flex: 1 }}>{main}</View>
                    {rightIcon || mode ? (<RightIcon accessibilityPreName={accessibilityPreName} icon={rightIcon} mode={mode} needScale={needScale} brandColor={customStyle.operationAreaColor ||
            customStyle.brandColor} onClose={this.onClose}/>) : null}
                </View>
            </TouchableWithoutFeedback>) : null;
    }
}
Tips.defaultProps = {
    mode: '',
    themeType: 'warning',
    onPress() { },
    needScale: false,
    accessibilityPreName: ''
};
